import type { JSX } from 'react';

import { Loader2 } from 'lucide-react';

import {
  UsersAlertDialog as AlertDialog,
  UsersAlertDialogAction as AlertDialogAction,
  UsersAlertDialogCancel as AlertDialogCancel,
  UsersAlertDialogContent as AlertDialogContent,
  UsersAlertDialogDescription as AlertDialogDescription,
  UsersAlertDialogFooter as AlertDialogFooter,
  UsersAlertDialogHeader as AlertDialogHeader,
  UsersAlertDialogTitle as AlertDialogTitle,
} from './ui/UsersAlertDialog';

interface IdentityExistsConfirmDialogProps {
  open: boolean;
  identityName: string | null;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const IdentityExistsConfirmDialog = ({
  open,
  identityName,
  isLoading,
  onClose,
  onConfirm,
}: IdentityExistsConfirmDialogProps): JSX.Element | null => {
  if (!open) return null;

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Ya existe una cuenta con este email</AlertDialogTitle>
          <AlertDialogDescription>
            {identityName ? <strong>{identityName}</strong> : 'Esta persona'} ya tiene una cuenta en otro proyecto.
            ¿Quieres que además tenga acceso a este proyecto?
          </AlertDialogDescription>
          <p className="text-sm text-error">
            El nombre, email y contraseña que completaste no se van a guardar. Se van a mantener los de la cuenta
            existente.
          </p>
          <p className="text-sm text-foreground">
            El usuario que se cree en este proyecto no tendrá permisos. Hay que asignárselos manualmente.
          </p>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading} onClick={onClose}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction disabled={isLoading} className="gap-2" onClick={onConfirm}>
            {isLoading ? <Loader2 className="size-4 animate-spin" aria-hidden /> : null}
            Agregar a este proyecto
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default IdentityExistsConfirmDialog;
